import { atom } from 'jotai'
import { AccountCapabilities } from 'types/capabilities/capabilities'

export const accountCapabilitiesAtom = atom({
  isPrincipleCustomerCompanyCapabilityEnabled: false,
  isPrincipleCustomerIndividualCapabilityEnabled: false,
  isBvnkNetworkCapabilityEnabled: false,
  isSwiftBeneficiaryCapabilityEnabled: false,
  isB2CBeneficiaryCapabilityEnabled: false,
  isCubixBeneficiaryCapabilityEnabled: false,
  isEmbeddedCustomerCompanyCapabilityEnabled: false,
  isEmbeddedCustomerIndividualCapabilityEnabled: false,
} as AccountCapabilities)
